import { render, staticRenderFns } from "./SummarySection.vue?vue&type=template&id=70cadae9&scoped=true&"
import script from "./SummarySection.vue?vue&type=script&lang=js&"
export * from "./SummarySection.vue?vue&type=script&lang=js&"
import style0 from "./SummarySection.vue?vue&type=style&index=0&id=70cadae9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cadae9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VLabel,VRow})
